import React from "react";
import {Button, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {InventoryReservation} from "../../../../api/Logistics";
import {Link} from "react-router-dom";
import {grey} from "@mui/material/colors";
import {useAsyncAction} from "nate-react-api-helpers";
import {api} from "../../../../api/API";

export function RemoveDialog(props: {
    onClose(): void;
    value: InventoryReservation;
}) {
    const removeReservation = useAsyncAction(async (input) => {
        await api.logistics.removeReservation(input);
        props.onClose();
    }, []);

    if(props.value.manufactureLog) {
        const url = window.location.host + `/manufacturing/po/${props.value.manufacturePo}`
        return (
            <Dialog2 open onClose={() => props.onClose()}>
                <DialogTitle>
                    Cannot Remove Reservation
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Please go to the link below and "Clear" the setup for the row that relies on this product.
                        <div>
                            PO#{props.value.manufacturePoNumber} <Link to={"http://" + url}>{url}</Link>
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => props.onClose()}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog2>
        )
    }

    return (
        <Dialog2 open onClose={() => props.onClose()}>
            <DialogTitle>
                Confirm Temporary Remove Reservation?
            </DialogTitle>
            <DialogContent>
                <DialogContentText style={{color: grey["900"]}}>
                    Removing this reservation will allow other projects to reserve this product if they have a nearer Needed By date.
                    <br/>
                    <div style={{height: 8}} />
                    Reservations will recalculate immediately after you confirm this action.
                    <div style={{height: 8}} />
                    Projects are automatically reserved in the background every day using this method:<br/>
                    <ul>
                        <li>Items that already have a reservation are not unreserved unless they are manufactured, shipped or manually unreserved by you</li>
                        <li>Items due in the next 2 weeks are given reservations based on Needed By date</li>
                        <li>If there is not enough to fully reserve an item, it will partially reserve what is available</li>
                    </ul>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.onClose()}>Cancel</Button>
                <Button variant="contained" onClick={() => {
                    removeReservation.callback({
                        id: props.value.id,
                        recalculate: true,
                    })
                }}>Confirm</Button>
            </DialogActions>
        </Dialog2>
    )
}